import type { RoleType, TeamMemberClass } from "@repo/types";

export const ROLES: RoleType[] = ["none", "view", "submit", "edit", "admin"];

export const CLASSES_LABELS: Record<TeamMemberClass, string> = {
  voting: "Voting",
  active: "Non-voting",
  support: "Support Only",
};
export const CLASSES = Object.keys(CLASSES_LABELS) as TeamMemberClass[];

export const LABEL_REVIEW_AGENDA_ITEM_BUTTON = "Record Decision";

export const KEYS = {
  AGENDAITEM_TABLE_COLUMNS: "civi-docs-agendaItemTableLayout",
  AGENDA_TABLE_COLUMNS: "civi-docs-agendaTableLayout",
  AGENDATEMPLATE_TABLE_COLUMNS: "civi-docs-agendaTemplateTableLayout",
  AGENDAMODULE_TABLE_COLUMNS: "civi-docs-agendaModuleTableLayout",
  MEETING_TABLE_COLUMNS: "civi-docs-meetingTableLayout",
  DOCUMENT_TABLE_COLUMNS: "civi-docs-documentTableLayout",
  SEARCHABLE_AGENDAMODULE_TABLE_COLUMNS:
    "civi-docs-searchableAgendaModuleTableLayout",
  SEARCHABLE_AGENDAITEM_TABLE_COLUMNS:
    "civi-docs-searchableAgendaItemTableLayout",
  SEARCHABLE_DOCUMENT_TABLE_COLUMNS: "civi-docs-searchableDocumentTableLayout",
  USER_TABLE_COLUMNS: "civi-docs-userTableLayout",
  TEAM_TABLE_COLUMNS: "civi-docs-teamTableLayout",
  TEAMMEMBER_TABLE_COLUMNS: "civi-docs-teamMemberTableLayout",
  LETTERHEAD_TABLE_COLUMNS: "civi-docs-letterheadTableLayout",
  ORDINANCES_TABLE_COLUMNS: "civi-docs-ordinancesTableLayout",
  DASHBOARD_LAYOUT: "civi-docs-dashboardLayout",
};

export const DATETIME_FORMAT = "MM/dd/yyyy h:mm:ss b";
export const DATE_FORMAT = "MM/dd/yyyy";

export const MEETING_MOTIF = "bg-tertiary";
export const AGENDA_MOTIF = "bg-tertiary";
export const AGENDA_MODULE_MOTIF = "bg-tertiary";
export const AGENDA_ITEM_MOTIF = "bg-primary";
export const DOCUMENT_MOTIF = "bg-[#c3ac88]";
